<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Роли пользователей системы</div>
        </div>
    </div>
    <table-element :actions="actions" :thead="thead" :tbody="tbody" @changeRights="changeRights"></table-element>
</template>

<script>
import AdminRole from "../../../models/AdminRole";
import TableElement from "../../../elements/TableElement";

export default {
    name: "AdminRolesComponent",
    components: {TableElement},
    props: {
        route_list: String,
        route_rights: String
    },
    data: function () {
        return {
            actions: [
                // {
                //     'text': 'Изменить права',
                //     'emit': 'changeRights',
                //     svg: `<button class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>`
                // }
            ],
            role: new AdminRole({
                route_list: this.route_list
            }),
            thead: [
                'Группа'
            ],
            tbody: []
        }
    },
    methods: {
        loadTable: async function () {
            let response = await this.role.loadTable();
            this.tbody = response.tbody;
        },
        changeRights: function (params) {
            location.href = this.route_rights+params.id;
        }
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
